import { render, staticRenderFns } from "./ModalExcluirPalavraBloqueada.vue?vue&type=template&id=3c4a4d9c&scoped=true"
import script from "./ModalExcluirPalavraBloqueada.vue?vue&type=script&lang=js"
export * from "./ModalExcluirPalavraBloqueada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4a4d9c",
  null
  
)

export default component.exports